// src/i18n/es/status.ts
// «Status page» (w7.u5, D30/B4) — route /status: el registro de huecos de
// ingesta por fuente, para IT y soporte. Página autenticada y acotada a una
// propiedad — no la variante pública/anónima que CF S6 también pide (D30),
// que queda pendiente de una decisión de producto de Cris.
export const status = {
  name: 'Estado |||| Estado',
  subtitle: 'Huecos en la recepción de datos por fuente, para IT y soporte',

  table: {
    title: 'Fuentes que cubren este hotel',
    source: 'Fuente',
    kind: 'Tipo',
    deliveryClass: 'Clase de entrega',
    status: 'Estado',
    totalGaps: 'Huecos totales',
    gapsByCounter: 'Huecos por contador',
    empty: 'Ninguna fuente cubre este hotel en el periodo elegido.',
  },

  kinds: {
    Kiosk: 'Kiosco',
    Gateway: 'Pasarela',
    Oci: 'Check-in online',
    BackOffice: 'Panel de gestión',
    DispenserShim: 'Dispensador',
    Partner: 'Integración externa',
    Locks: 'Cerraduras',
    Assistant: 'Asistente del huésped',
    other: 'Otra fuente',
  },

  delivery: {
    Durable: 'Garantizada',
    Lossy: 'Sin garantía',
    other: 'Desconocida',
  },

  states: {
    Active: 'Activa',
    Suspended: 'Suspendida',
    Revoked: 'Revocada',
    other: 'Desconocido',
  },

  help: {
    title: 'Estado',
    description:
      'El registro de huecos en la recepción de datos de Insight, por fuente, para el hotel y el periodo elegidos (por defecto las últimas 48 horas). Esta es la variante interna y acotada a un hotel; una variante pública y anónima es una decisión de producto pendiente.',
    features: {
      list: 'Cada fuente muestra su tipo, su clase de entrega, su estado y sus huecos totales y por contador.',
    },
    tips: {
      property: 'Cambie de hotel arriba a la izquierda; el periodo por defecto son las últimas 48 horas.',
    },
  },
};

export default status;
